import React from 'react';
import styles from './search_results.scss';
import { getHighlightString } from "../../utills";
import withRipple from "jd-library/withRipple";
import Button from 'jd-library/Button';

const SearchResults = props => {
    let { item, onEleClick, searchKey, manageTaxes } = props;
    let isNumericSearch = !isNaN(searchKey);
    const highlightText = text => {
        return getHighlightString({
            searchKey: searchKey,
            searchResult: text
        });
    };
    if (manageTaxes) {
		return (
			<div
				className={
					styles['search-taxes-suggestion'] + ' ' 
				}
				{...props.rippleHandler}
				onClick={()=>onEleClick(item)}
			>
				<div className={styles['left-sec']}>
					<div
						className={styles['result-title']}
						dangerouslySetInnerHTML={{
							__html: isNumericSearch
								? highlightText(item.hsn_code)
								: item.hsn_code
						}}
					></div>
					<div className={styles['tax-details']}>
						<span style={{color: '#718190'}}>GST Tax Rate: </span>
						{item.gst ? item.gst + '%' : 'Not Available'}
					</div>
				</div>
				<div
                    className={styles['gray-txt']}
					dangerouslySetInnerHTML={{
                        __html: isNumericSearch
                            ? item.commodity
                            : highlightText(item.commodity)
                    }}
				>
				</div>
				<div className={styles['divider']}></div>
				{props.renderRipple()}
				<Button 
					className={styles['select-btn']}
					variant={'default'}
					// clickHandler={() => {
					// 	onEleClick(item);
					// }}
					children={'Select'}
				/>
			</div>
		);
	}
    return (
        <div className={styles['search-suggestion'] + ' ' + props.rippleClass} onClick={() => setTimeout(() => { onEleClick(item) }, 300)} {...props.rippleHandler}>
            <div className={styles['left-sec']}>
                <div className={styles['result-title']} dangerouslySetInnerHTML={{ __html: isNumericSearch ? highlightText(item.hsn_code) : item.hsn_code }}></div>
                <div className={styles['gray-txt']} dangerouslySetInnerHTML={{ __html: isNumericSearch ? item.commodity : highlightText(item.commodity) }}></div>
            </div>
            <div className={styles['right-sec'] + ' ' + styles['result-title']}>{item.gst ? item.gst + '%' : 'Not Available'}</div>
            <div className={styles['divider']}></div>
            {props.renderRipple()}
        </div>
    );
}

export default withRipple(SearchResults);